import { logger } from '@shared/lib/logger/logger-manager';
import { IStoreApiState } from './api.interface';

/**
 * Clear all cancel tokens
 * @param {IStoreApiState} that
 */
export const _clearApiRequests = (that: IStoreApiState) => {
  if (that.apiAbortControllerArray) {
    that.apiAbortControllerArray.forEach((advancedController) => {
      advancedController?.abort();
    });

    that.apiAbortControllerArray = [];
  }
};

/**
 * Remove cancelToken
 * @param {IStoreApiState} that
 * @param {AbortController} abortController
 */
export const _removeAbortController = (
  that: IStoreApiState,
  abortController: AbortController,
) => {
  if (that.apiAbortControllerArray) {
    for (let index = 0; index < that?.apiAbortControllerArray.length; index++) {
      if (that.apiAbortControllerArray[index] === abortController) {
        that.apiAbortControllerArray.splice(index, 1);
      }
    }
  }
};

/**
 * Add cancelToken
 * @param {IStoreApiState} that
 * @param {AbortController} abortSignal
 */
export const _addAbortController = (
  that: IStoreApiState,
  abortController: AbortController,
) => {
  if (that.apiAbortControllerArray) {
    if (!that.apiAbortControllerArray.some((c) => c === abortController)) {
      that.apiAbortControllerArray.push(abortController);
    }
  }
};

/**
 * Clear all states
 * @param {IStoreApiState} that
 */
export const _clear = (that: IStoreApiState) => {
  if (that?.apiAbortControllerArray) that.apiAbortControllerArray = undefined;
};
